<template>
  <div class="data-table-list-client" :class="size" style="padding: 0px 10px;" v-if="activate >= 15 || activate == 11">
    <el-dropdown trigger="click" placement="bottom-start" :hide-on-click="true" @visible-change="dropdown = id">
      <el-tooltip content="ブランドを追加" placement="top" :disabled="!size">
        <div class="data-table-list-status-button pointer" style="margin-left:10px;" v-if="list.target_client_id">
          <img :src="list.target_client_img_url" class="list-member-profile" :class="size" v-if="list.target_client_img_url != null" />
          <div v-else class="list-member-noimg assign" :class="size">{{ list.target_client_name | firstLetter }}</div>
        </div>
        <div class="data-table-list-status-button pointer" v-else>
          <div class="list-member-user" :class="size">
            <font-awesome-icon :icon="['fas', 'buildings']" :class="size ? 'list-member-user-icon--small' : ''" />
            <font-awesome-icon icon="plus-circle" class="list-member-plus" :class="size" />
          </div>
        </div>
      </el-tooltip>
      <el-dropdown-menu slot="dropdown">
        <div v-if="dropdown == id">
          <el-dropdown-item
            style="font-size:12px;"
            v-for="target_client in target_client"
            :key="target_client.id"
            class="member"
            @click.native="list.target_client_id == target_client.target_client_id ? '' : changeTargetClient(target_client.target_client_id, id, index)"
            :class="list.target_client_id == target_client.target_client_id ? 'assign' : ''"
          >
            <img :src="target_client.img_url" class="list-member-profile dropdown" v-if="target_client.img_url != null" />
            <div class="list-member-noimg dropdown" v-else>{{ target_client.target_client_name | firstLetter }}</div>
            <div class="list-member-dropdown-namearea">
              <div>{{ target_client.target_client_name }}</div>
              <div v-if="list.target_client_id == target_client.target_client_id">
                <div class="pointer times-circle" @click="deleteClient(target_client.target_client_id, id, index)">
                  <font-awesome-icon icon="times-circle" />
                </div>
              </div>
            </div>
          </el-dropdown-item>
          <router-link :to="{ name: 'setting', query: { activeName: 'brand' } }">
            <el-dropdown-item :divided="target_client.length > 0">
              <i class="el-icon-plus"></i>
              ブランドを追加する
            </el-dropdown-item>
          </router-link>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "brandDropdown",
  props: ["id", "list", "target_client", "index", "size"],
  data() {
    return {
      dropdown: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  methods: {
    changeTargetClient(target_client_id, list_id, list_index) {
      this.$emit("changeTargetClient", target_client_id, list_id, list_index);
    },
    deleteClient(target_client_id, list_id, list_index) {
      this.$emit("deleteClient", target_client_id, list_id, list_index);
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
